// extracted by mini-css-extract-plugin
module.exports = {"borderStyle":"style_borderStyle__jVGFi","paragraphColor":"style_paragraphColor__PbSOy","xStyle":"style_xStyle__21W7L","ticStyle":"style_ticStyle__9YM1D"};